import {
  GetManagerSelfServiceSettings,
  GetManagerSelfServiceSettingsSuccess,
  GetManagerSelfServiceSettingsError,
  UpdateManagerSelfServiceSettings,
  UpdateManagerSelfServiceSettingsSuccess,
  UpdateManagerSelfServiceSettingsError,
} from "@modules/service/constants/actions";
import * as managerSelfServiceReducers from "./reducers";
import initialState from "./state";
import type { ManagerSelfServiceState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: ManagerSelfServiceState = initialState,
  action: Object,
): ManagerSelfServiceState => {
  const act = {
    [GetManagerSelfServiceSettings]: managerSelfServiceReducers.onGetManagerSelfServiceSettings,
    [GetManagerSelfServiceSettingsSuccess]:
      managerSelfServiceReducers.onGetManagerSelfServiceSettingsSuccess,
    [GetManagerSelfServiceSettingsError]:
      managerSelfServiceReducers.onGetManagerSelfServiceSettingsError,

    [UpdateManagerSelfServiceSettings]:
      managerSelfServiceReducers.onUpdateManagerSelfServiceSettings,
    [UpdateManagerSelfServiceSettingsSuccess]:
      managerSelfServiceReducers.onUpdateManagerSelfServiceSettingsSuccess,
    [UpdateManagerSelfServiceSettingsError]:
      managerSelfServiceReducers.onUpdateManagerSelfServiceSettingsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
